import { render, staticRenderFns } from "./last-md-contents.vue?vue&type=template&id=22b68aaa&scoped=true&lang=pug&"
import script from "./last-md-contents.vue?vue&type=script&lang=js&"
export * from "./last-md-contents.vue?vue&type=script&lang=js&"
import style0 from "./last-md-contents.vue?vue&type=style&index=0&id=22b68aaa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b68aaa",
  null
  
)

export default component.exports